import React, { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { createEngagementBudget, createEngagementTransactions, getMonthlyTransactionData } from "../../../store/engagementMetricsSlice";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ZoomIn } from "lucide-react";
dayjs.extend(customParseFormat);

const AddFinancialDataModal = ({
  isOpen,
  onClose,
}) => {
  const [startMonth, setStartMonth] = useState("");
  const dispatch = useDispatch();
  const [endMonth, setEndMonth] = useState("");
  const [monthsData, setMonthsData] = useState([]);
  const [selectedFinancialTab, setSelectedFinancialTab] = useState("Budget");
  const [selectedCheckbox, setSelectedCheckbox] = useState("Single");
  const user = useSelector((state) => state.auth.userDetails.userDetails);
  const [singleTransaction, setSingleTransaction] = useState({
    transactionId: "",
    date: "",
    description: "",
    category: "",
    amount: "",
  });
   const supplier = useSelector((state) => state.auth.selectedSupplier);
   const userId = useSelector((state) => state.auth.id);

  const [transactionsData, setTransactionsData] = useState([
    {
      transactionId: "",
      date: "",
      description: "",
      category: "",
      amount: "",
    },
  ]);

  const [isApplied, setApplied] = useState(false);

  const dayjs = require("dayjs");

  const handleApply = () => {
    if (!startMonth || !endMonth) return;

    setApplied(true);

    const start = dayjs(startMonth);
    const end = dayjs(endMonth);
    const newData = [...monthsData]; 

    let current = start.startOf("month");
    while (current.isBefore(end) || current.isSame(end, "month")) {
      const monthName = current.format("MMMM");
      const year = current.year();

      const alreadyExists = newData.some(
        (item) => item.month === monthName && item.year === year
      );

      if (!alreadyExists) {
        newData.push({
          month: monthName,
          year: year,
          budget: "",
        });
      }

      current = current.add(1, "month");
    }

    setMonthsData(newData);
  };

  const formatDateInput = (value) => {
    const parts = value.split(/\D+/).filter(Boolean);

    if (parts.length < 3) return value;

    let [month, day, year] = parts;

    month = month.padStart(2, "0");
    day = day.padStart(2, "0");

    if (year.length === 2) {
      year = year > "30" ? `19${year}` : `20${year}`;
    }

    return `${month}/${day}/${year}`;
  };

  const handleBlur = (index, field, value) => {
    if (field === "date") {
      const formattedDate = formatDateInput(value);
      const newData =
        selectedFinancialTab === "Budget"
          ? [...monthsData]
          : [...transactionsData];
      newData[index][field] = formattedDate;
      selectedFinancialTab === "Budget"
        ? setMonthsData(newData)
        : setTransactionsData(newData);
    }
  };
  const numberToMonthName = (num) => {
    const map = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec",
    };
    return map[num] || "Jan";
  };

  const handleChange = (indexOrField, field, value) => {
    const cleanValue = value.replace(/[^0-9,\.]/g, "").replace(",", ".");
    const numberValue = Number(cleanValue);

    if (cleanValue === "" || isNaN(numberValue)) return;

    if (selectedCheckbox === "Single") {
      if (!startMonth) return;

      const [yearStr, monthStr] = startMonth.split("-");
      const year = parseInt(yearStr, 10);
      const monthName = numberToMonthName(monthStr);

      const existingIndex = monthsData.findIndex(
        (item) => item.year === year && item.month === monthName
      );

      const newData = [...monthsData];

      if (existingIndex !== -1) {
        newData[existingIndex].budget = cleanValue;
      } else {
        newData.push({
          month: monthName,
          year: year,
          budget: cleanValue,
        });
      }

      setMonthsData(newData);
    } else {
      const newData = [...monthsData];
      const index = indexOrField;
      newData[index][field] = cleanValue;
      setMonthsData(newData);
    }
  };


  const handleSingleTransactionChange = (field, value) => {
    const cleanValue = value.replace(/[^0-9a-zA-Z\s,./-]/g, "");
    setSingleTransaction((prev) => ({ ...prev, [field]: cleanValue }));
  };

const handleSaveSingleTransaction = () => {
  const updatedTransactions = [...transactionsData, singleTransaction];

  setTransactionsData(updatedTransactions);

  setSingleTransaction({
    transactionId: "",
    date: "",
    description: "",
    category: "",
    amount: "",
  });

  onClose();
};

  const handleTransactionsChange = (indexOrField, field, value) => {
    const cleanValue = value.replace(/[^0-9a-zA-Z\s,./-]/g, "");
    const index = indexOrField;
    const updated = [...transactionsData];
    updated[index][field] = cleanValue;
    setTransactionsData(updated);
  };

  const addStepTwoRow = () => {
    setTransactionsData((prev) => [
      ...prev,
      {
        transactionId: "",
        date: "",
        description: "",
        category: "",
        amount: "",
      },
    ]);
  };

const handleSave = async () => {
 

 const budgetPayload = monthsData.map((s) => {
  const monthIndex = new Date(`${s.month} 1, ${s.year}`).getMonth();
   const isoDate = new Date(s.year, monthIndex, 1).toISOString();
const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;

    return {
      supplierId: supplier._id,
      buyerId: buyerIdToUse,
      date: isoDate,
      month: s.month,
      year: s.year,
      amount: s.budget, 
    };
  });

  await dispatch(createEngagementBudget(budgetPayload));
  const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;
  dispatch(getMonthlyTransactionData({supplierId: supplier._id, buyerId: buyerIdToUse}))
  onClose();
  setApplied(false);
  setStartMonth("");
  setEndMonth("");
};


const handleSaveTransactions = async () => {
const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;
  const structuredTransactions = transactionsData.map((txn) => ({
    supplierId: supplier._id,
    buyerId: buyerIdToUse,
    date: txn.date, 
    transactionId: txn.transactionId,
    description: txn.description,
    category: txn.category,
    amount: txn.amount,
    status: txn.status,
  }));

  await dispatch(createEngagementTransactions(structuredTransactions));
  dispatch(getMonthlyTransactionData({supplierId: supplier._id, buyerId: buyerIdToUse}))


  onClose();
  setApplied(false);
};

  const handleCancel = () => {
    onClose();
    setApplied(false);
  };

  const handleMultiRowPaste = (e, startIndex, field) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");

    const lines = paste.split(/\r?\n/).filter((line) => line.trim() !== "");

    const updated = [...monthsData];

    lines.forEach((value, i) => {
      const targetIndex = startIndex + i;
      if (targetIndex < updated.length) {
        let newValue = value.trim();

        if (field === "budget" || field === "amount") {
          const cleanValue = newValue
            .replace(/[^0-9,\.]/g, "")
            .replace(",", ".");
          const numberValue = Number(cleanValue);

          if (cleanValue === "" || !isNaN(numberValue)) {
            updated[targetIndex][field] = cleanValue;
          }
        } else {
          updated[targetIndex][field] = newValue;
        }
      }
    });

    setMonthsData(updated);
  };

  const columnOrder = [
    "transactionId",
    "date",
    "description",
    "category",
    "amount",
  ];
  const handleTransactionsMultiRowPaste = (e, rowIndex, startingKey) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");

    const rows = pastedText.split(/\r?\n/).filter((row) => row.trim() !== "");
    const parsedRows = rows.map((row) => row.split(/\t|,/));

    const startColIndex = columnOrder.indexOf(startingKey);

    setTransactionsData((prev) => {
      const updated = [...prev];

      parsedRows.forEach((cells, i) => {
        const targetRowIndex = rowIndex + i;

        if (!updated[targetRowIndex]) {
          updated[targetRowIndex] = {
            transactionId: "",
            date: "",
            description: "",
            category: "",
            amount: "",
          };
        }

        cells.forEach((cell, j) => {
          const colIndex = startColIndex + j;
          if (colIndex < columnOrder.length && cell?.trim?.()) {
            const key = columnOrder[colIndex];
            let value = cell.trim();

            if (key === "date") {
              value = formatDateInput(value);
            }

            updated[targetRowIndex][key] = value;
          }
        });
      });

      return updated;
    });
  };

  const formatCurrency = (value) => {
    if (!value) return "";
    return `$ ${value}`;
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative" style={{zIndex: 10000}} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Dialog.Panel className=" ml-20 w-full max-w-[800px] transform overflow-hidden rounded-lg bg-white p-10 shadow-xl transition-all">
              <Dialog.Title className="text-lg font-semibold">
                Financial Data
              </Dialog.Title>
              <div className="flex flex-row justify-center items-center gap-10 mb-8 mt-8">
                <span
                  onClick={() => setSelectedFinancialTab("Budget")}
                  className={`
  px-4 py-1 border-b text-base
  ${
    selectedFinancialTab === "Budget"
      ? "border-b-blue-500 border-b-2"
      : "text-gray-600 hover:text-gray-400 border-b-transparent"
  }
`}
                >
                  Budget
                </span>
                                <span
                  onClick={() => setSelectedFinancialTab("Spend")}
                  className={`
  px-4 py-1 border-b text-base
  ${
    selectedFinancialTab === "Spend"
      ? "border-b-blue-500 border-b-2"
      : "text-gray-600 hover:text-gray-400 border-b-transparent"
  }
`}
                >
                  Spend
                </span>
                <span
                  onClick={() => setSelectedFinancialTab("Transaction")}
                  className={`
  px-4 py-1 border-b text-base
  ${
    selectedFinancialTab === "Transaction"
      ? "border-b-blue-500 border-b-2"
      : "text-gray-600 hover:text-gray-400 border-b-transparent"
  }
`}
                >
                  Transaction
                </span>
              </div>
              <div className="flex flex-col gap-2 justify-start items-start mb-6">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="dataType"
                    value="Single"
                    checked={selectedCheckbox === "Single"}
                    onChange={() => setSelectedCheckbox("Single")}
                  />
                  Single Data
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="dataType"
                    value="Bulk"
                    checked={selectedCheckbox === "Bulk"}
                    onChange={() => setSelectedCheckbox("Bulk")}
                  />
                  Bulk Data
                </label>
              </div>

              {selectedFinancialTab === "Budget" &&
                (selectedCheckbox === "Single" ? (
                  <div className="flex flex-col">
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 mr-12 font-medium">
                        Month
                      </label>
                      <input
                        type="month"
                        value={startMonth}
                        placeholder="Jan 2025"
                        onChange={(e) => setStartMonth(e.target.value)}
                        className=" border rounded bg-[#F4F4F4] p-2 w-[466px]"
                      />
                    </div>
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-10">
                        Amount
                      </label>
                      <input
                        type="text"
                        // value={formatCurrency()}
                        placeholder="$ 100,000"
                        onChange={(e) =>
                          handleChange(null, "budget", e.target.value)
                        }
                        className=" border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2 mt-12">
                      <button
                        className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                        onClick={handleSave}
                      >
                        Save Data
                      </button>
                      <span
                        className="text-[#7E7E7E] mt-2 cursor-pointer "
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-4 mb-4">
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-8">
                        Start Month
                      </label>
                      <input
                        type="month"
                        value={startMonth}
                        onChange={(e) => setStartMonth(e.target.value)}
                        className="border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-10">
                        End Month
                      </label>
                      <input
                        type="month"
                        value={endMonth}
                        onChange={(e) => setEndMonth(e.target.value)}
                        className="border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <button
                      onClick={handleApply}
                      className="self-start bg-[#EAF524] px-4 py-2 rounded font-medium"
                    >
                      Apply
                    </button>

                    {isApplied && (
                      <>
                        <span className="mt-8 font-medium text-xl text-[#1D2739]">
                          Input Data
                        </span>
                        <table className="w-full text-sm border-b table-fixed">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="border-r px-2 py-4 text-sm text-center align-middle">
                                Timeframe (Months)
                              </th>
                              <th className="px-2 py-4 text-sm text-center align-middle">
                                Budget*
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {monthsData.map((item, idx) => (
                              <tr key={idx}>
                                <td className="border-r border-b text-center align-middle py-[17px] px-4">
                                  <input
                                    type="text"
                                    value={`${item.month} ${item.year}`}
                                    className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0 text-center"
                                  />
                                </td>
                                <td className="border-b text-center align-middle py-[17px] px-4">
                                  <input
                                    type="text"
                                    value={formatCurrency(item.budget)}
                                    onPaste={(e) =>
                                      handleMultiRowPaste(e, idx, "budget")
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        idx,
                                        "budget",
                                        e.target.value
                                      )
                                    }
                                    className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0 text-center"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="flex flex-col justify-center items-center gap-2 mt-12">
                          <button
                            className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                            onClick={handleSave}
                          >
                            Save Data
                          </button>
                          <span
                            className="text-[#7E7E7E] mt-2 cursor-pointer "
                            onClick={() => handleCancel()}
                          >
                            Cancel
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                ))}

                {selectedFinancialTab === "Spend" &&
                (selectedCheckbox === "Single" ? (
                  <div className="flex flex-col">
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 mr-12 font-medium">
                        Month
                      </label>
                      <input
                        type="month"
                        value={startMonth}
                        placeholder="Jan 2025"
                        onChange={(e) => setStartMonth(e.target.value)}
                        className=" border rounded bg-[#F4F4F4] p-2 w-[466px]"
                      />
                    </div>
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-10">
                        Amount
                      </label>
                      <input
                        type="text"
                        // value={formatCurrency()}
                        placeholder="$ 100,000"
                        onChange={(e) =>
                          handleChange(null, "spend", e.target.value)
                        }
                        className=" border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2 mt-12">
                      <button
                        className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                        // onClick={handleSave}
                      >
                        Save Data
                      </button>
                      <span
                        className="text-[#7E7E7E] mt-2 cursor-pointer "
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-4 mb-4">
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-8">
                        Start Month
                      </label>
                      <input
                        type="month"
                        value={startMonth}
                        onChange={(e) => setStartMonth(e.target.value)}
                        className="border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <div className="flex flex-row justify-start items-center mb-6">
                      <label className="block mb-1 font-medium mr-10">
                        End Month
                      </label>
                      <input
                        type="month"
                        value={endMonth}
                        onChange={(e) => setEndMonth(e.target.value)}
                        className="border rounded bg-[#F4F4F4] p-2 w-[466px] h-[42px]"
                      />
                    </div>
                    <button
                      onClick={handleApply}
                      className="self-start bg-[#EAF524] px-4 py-2 rounded font-medium"
                    >
                      Apply
                    </button>

                    {isApplied && (
                      <>
                        <span className="mt-8 font-medium text-xl text-[#1D2739]">
                          Input Data
                        </span>
                        <table className="w-full text-sm border-b table-fixed">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="border-r px-2 py-4 text-sm text-center align-middle">
                                Timeframe (Months)
                              </th>
                              <th className="px-2 py-4 text-sm text-center align-middle">
                                Amount*
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {monthsData.map((item, idx) => (
                              <tr key={idx}>
                                <td className="border-r border-b text-center align-middle py-[17px] px-4">
                                  <input
                                    type="text"
                                    value={`${item.month} ${item.year}`}
                                    className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0 text-center"
                                  />
                                </td>
                                <td className="border-b text-center align-middle py-[17px] px-4">
                                  <input
                                    type="text"
                                    value={formatCurrency(item.amount)}
                                    onPaste={(e) =>
                                      handleMultiRowPaste(e, idx, "amount")
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        idx,
                                        "amount",
                                        e.target.value
                                      )
                                    }
                                    className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0 text-center"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="flex flex-col justify-center items-center gap-2 mt-12">
                          <button
                            className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                            // onClick={handleSave}
                          >
                            Save Data
                          </button>
                          <span
                            className="text-[#7E7E7E] mt-2 cursor-pointer "
                            onClick={() => handleCancel()}
                          >
                            Cancel
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                ))}

              {selectedFinancialTab === "Transaction" &&
                (selectedCheckbox === "Single" ? (
                  <>
                    <div className="flex flex-col">
                      <div className="flex flex-row justify-start items-center mb-6">
                        <label className="block mb-1 mr-12 font-medium">
                          Date
                        </label>
                        <input
                          type="date"
                          value={singleTransaction.date}
                          onChange={(e) =>
                            handleSingleTransactionChange(
                              "date",
                              e.target.value
                            )
                          }
                          className=" border rounded bg-[#F4F4F4] p-2 w-[466px]"
                        />
                      </div>
                      <div className="flex flex-row justify-start items-center mb-6">
                        <label className="block mb-1 font-medium mr-7">
                          Amount
                        </label>
                        <input
                          type="text"
                          value={singleTransaction.amount}
                          onChange={(e) =>
                            handleSingleTransactionChange(
                              "amount",
                              e.target.value
                            )
                          }
                          className=" border rounded bg-[#F4F4F4] p-2 w-[466px] h-[48px]"
                        />
                      </div>
                      {/* <label className="block mb-1 font-medium mr-10">
                        Transaction ID
                      </label>
                      <input
                        type="text"
                        // value={formatCurrency(item.budget)}
                        placeholder="AD112234"
                        onChange={(e) =>
                          handleChange(null, "transactionId", e.target.value)
                        }
                        className=" border rounded bg-[#F4F4F4] p-2 w-full h-[48px] mb-6"
                      /> */}
                      <label className="block mb-1 font-medium mr-10">
                        Description
                      </label>
                      <textarea
                        type="text"
                        rows={4}
                        // value={formatCurrency(item.budget)}
                        placeholder="Detailed Description"
                        onChange={(e) =>
                          handleChange(null, "description", e.target.value)
                        }
                        className=" border rounded bg-[#F4F4F4] p-2 w-full mb-6"
                      />
                      <label className="block mb-1 font-medium mr-10">
                        Category
                      </label>
                      <input
                        type="text"
                        // value={formatCurrency(item.budget)}
                        placeholder="Materials"
                        onChange={(e) =>
                          handleChange(null, "category", e.target.value)
                        }
                        className=" border rounded bg-[#F4F4F4] p-2 w-full h-[48px] mb-6"
                      />
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2 mt-12">
                      <button
                        className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                        onClick={handleSaveSingleTransaction}
                      >
                        Save Data
                      </button>
                      <span
                        className="text-[#7E7E7E] mt-2 cursor-pointer "
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <table className="w-full text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          {/* <th className="border-r px-2 py-4 text-sm whitespace-nowrap">
                            Transaction ID
                          </th> */}
                          <th className="border-r px-2 py-4 text-sm">
                            Date(MM/DD/YYYY)
                          </th>
                          <th className="border-r text-sm whitespace-nowrap">
                            Product Description
                          </th>
                          <th className="border-r px-8 py-4 text-sm">
                            Category
                          </th>
                          <th className=" border-r px-4 py-4 text-sm">
                            Amount*
                          </th>
                          <th className="px-2 py-4"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactionsData.map((item, idx) => (
                          <tr key={idx}>
                            {/* <td className=" border-r border-b text-center align-middle py-[17px] px-4">
                              <input
                                type="text"
                                className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                                value={item.transactionId}
                                onPaste={(e) =>
                                  handleTransactionsMultiRowPaste(
                                    e,
                                    idx,
                                    "transactionId"
                                  )
                                }
                                onChange={(e) =>
                                  handleTransactionsChange(
                                    idx,
                                    "transactionId",
                                    e.target.value
                                  )
                                }
                              />
                            </td> */}
                            <td className="border-r border-b text-center align-middle py-[17px] px-4">
                              <input
                                type="text"
                                className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                                value={item.date}
                                onPaste={(e) =>
                                  handleTransactionsMultiRowPaste(
                                    e,
                                    idx,
                                    "date"
                                  )
                                }
                                onChange={(e) =>
                                  handleTransactionsChange(
                                    idx,
                                    "date",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleBlur(idx, "date", e.target.value)
                                }
                                placeholder="MM/DD/YYYY"
                                maxLength={10}
                              />
                            </td>

                            <td className="border-r border-b text-center align-middle py-[17px] px-4">
                              <input
                                type="text"
                                className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                                value={item.description}
                                onPaste={(e) =>
                                  handleTransactionsMultiRowPaste(
                                    e,
                                    idx,
                                    "description"
                                  )
                                }
                                onChange={(e) =>
                                  handleTransactionsChange(
                                    idx,
                                    "description",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td className="border-r border-b text-center align-middle py-[17px] px-4">
                              <input
                                type="text"
                                className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                                value={item.category}
                                onPaste={(e) =>
                                  handleTransactionsMultiRowPaste(
                                    e,
                                    idx,
                                    "category"
                                  )
                                }
                                onChange={(e) =>
                                  handleTransactionsChange(
                                    idx,
                                    "category",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td className=" border-r border-b text-center align-middle py-[17px] px-4">
                              <input
                                type="text"
                                className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                                value={item.amount}
                                onPaste={(e) =>
                                  handleTransactionsMultiRowPaste(
                                    e,
                                    idx,
                                    "amount"
                                  )
                                }
                                onChange={(e) =>
                                  handleTransactionsChange(
                                    idx,
                                    "amount",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td className=" text-center">
                              <button
                                onClick={() => {
                                  const updated = transactionsData.filter(
                                    (_, i) => i !== idx
                                  );
                                  setTransactionsData(updated);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="15"
                                  viewBox="0 0 14 15"
                                  fill="none"
                                >
                                  <path
                                    d="M8.82667 5.49937L8.596 11.4994M5.404 11.4994L5.17333 5.49937M11.8187 3.35937C12.0467 3.39404 12.2733 3.43071 12.5 3.47004M11.8187 3.35937L11.1067 12.6147C11.0776 12.9915 10.9074 13.3435 10.63 13.6002C10.3527 13.8569 9.9886 13.9995 9.61067 13.9994H4.38933C4.0114 13.9995 3.64735 13.8569 3.36999 13.6002C3.09262 13.3435 2.92239 12.9915 2.89333 12.6147L2.18133 3.35937M11.8187 3.35937C11.0492 3.24305 10.2758 3.15477 9.5 3.09471M2.18133 3.35937C1.95333 3.39337 1.72667 3.43004 1.5 3.46937M2.18133 3.35937C2.95076 3.24305 3.72416 3.15477 4.5 3.09471M9.5 3.09471V2.48404C9.5 1.69737 8.89333 1.04137 8.10667 1.0167C7.36908 0.99313 6.63092 0.99313 5.89333 1.0167C5.10667 1.04137 4.5 1.69804 4.5 2.48404V3.09471M9.5 3.09471C7.83581 2.96609 6.16419 2.96609 4.5 3.09471"
                                    stroke="#FF0000"
                                    stroke-width="1.11111"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button
                      onClick={addStepTwoRow}
                      className="mt-2 text-blue-600 font-medium"
                    >
                      + Add Row
                    </button>

                    <div className="flex flex-col justify-center items-center gap-2 mt-12">
                      <button
                        className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                        onClick={handleSaveTransactions}
                      >
                        Save Data
                      </button>
                      <span
                        className="text-[#7E7E7E] mt-2 cursor-pointer "
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </span>
                    </div>
                  </>
                ))}
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AddFinancialDataModal;
